import { ScraperHeader } from './ScraperHeader';
import { ScraperMain } from './ScraperMain';
import { useScraper } from './state/context';

export const Scraper = () => {
  const { target } = useScraper();

  return (
    <div className='flex w-full flex-col gap-4'>
      <ScraperHeader />
      <ScraperMain key={target.name} />
    </div>
  );
};
